import React, { createContext, useContext, useState } from "react";

import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/system";
import {
  coreDarkTheme,
  coreLightTheme,
  gravityDarkTheme,
  gravityLightTheme,
} from "./clients";

interface ThemeContextType {
  darkMode: boolean;
  toggleDarkMode: () => void;
}

const Theme = createContext<ThemeContextType | undefined>(undefined);

declare module "@mui/material/styles" {
  interface Palette {
    gradient: string[];
  }

  interface PaletteOptions {
    gradient?: string[]
  }
}


export const ThemeProviderWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [darkMode, setDarkMode] = useState(true);

  const client = process.env.REACT_APP_CLIENT || 'core';
  let darkTheme = undefined;
  let lightTheme = undefined;

  if (client === 'gravity') {
    darkTheme = createTheme(gravityDarkTheme);
    lightTheme = createTheme(gravityLightTheme);
  } else {
    darkTheme = createTheme(coreDarkTheme);
    lightTheme = createTheme(coreLightTheme);
  }

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  const theme = darkMode ? darkTheme : lightTheme;

  return (
    <ThemeProvider theme={theme}>
      <Theme.Provider value={{ darkMode, toggleDarkMode }}>
        {children}
      </Theme.Provider>
    </ThemeProvider>
  );
};

export const useThemeMode = () => {
  const context = useContext(Theme);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
